import HttpError from "../http_error";
import weatherRoutingAxiosInstance from "../weather_routing_axios_instance";
export default class WeatherRoutingCompanyService {
  constructor(baseUrl, companyId, companyDataFromJsonMapper) {
    this.baseUrl = baseUrl;
    this.companyDataFromJsonMapper = companyDataFromJsonMapper;
    this.companyId = companyId;
  }

  async getOne(accessToken) {
    try {
      const response = await weatherRoutingAxiosInstance.get(
        `${this.baseUrl}/company/${this.companyId}`,
        {
          headers: { "access-token": `${accessToken}` },
        }
      );
      return this.companyDataFromJsonMapper(response.data);
    }
    catch (error) {
      return HttpError(error.response.statusText, error.response.status);
    }

  }
}
